<template>
  <section id="canvas"></section>
</template>

<script>
import Faces from '@/scripts/faces';

export default {
  name: 'IndexFace',

  mounted() {
    this.init();
  },

  beforeDestroy() {
    setTimeout(() => {
      this.faces.destroy();
    }, 1400);
  },

  methods: {
    init() {
      this.faces = new Faces({
        cols: 4,
        elements: 12,
        urlImg: '/static/img/faces/faceoftheworld_load.jpg',
        perspective: 1000,
        callback: this.setScale,
      });
    },

    setScale() {
      const el = this.faces.ctx;

      el.style.transform = 'scale(6)';
    },
  },
};
</script>

<style lang="scss" scoped>
#canvas {
  position: fixed;
  top: 20%;
  left: 20%;
  width: 60%;
  height: 60%;

  z-index: 0;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexFace.vue